export default __webpack_public_path__ + "static/fb-ebdf5d82a2a886f46652833991d8ad86.jpg";